// extracted by mini-css-extract-plugin
module.exports = {"container":"TitledPage_container__1HwK1","title":"TitledPage_title__t8Ti5","page":"TitledPage_page__36nCT"};